import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["item", "intersect", "slider"];
import { FavoriteButton } from "@/components/Buttons";
import CardArtwork from "@/components/Card/CardArtwork";
import { useSliderPosition } from "@/hooks";
import { deliveryDate, deliveryLabel, price } from "@/lib/metaUtil";
import routes from "@/lib/routes";
import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import { CardContext } from "@/components/Card/CardContext";
import { useContext, useRef, useCallback } from "react";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EpisodeCard(props) {
  var _item$channel;

  var item = props.item,
      intersect = props.intersect,
      slider = props.slider,
      props_ = _objectWithoutProperties(props, _excluded);

  var cardRef = useRef();
  var classNames = useSliderPosition(props_, cardRef);
  var context = useContext(CardContext);
  var channelId = Number(item === null || item === void 0 ? void 0 : (_item$channel = item.channel) === null || _item$channel === void 0 ? void 0 : _item$channel.id);
  var showValuePlanLabel = isShowValuePlanLabel({
    channelId: channelId
  });
  var handleClick = useCallback(function (e) {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    ref: cardRef,
    className: classnames(classNames, _defineProperty({}, styles.notAllowed, !item.isAllowedRating)),
    children: /*#__PURE__*/_jsx(VersatileLink, {
      href: routes.watchWithRtsid(item),
      children: /*#__PURE__*/_jsx("a", {
        onClick: handleClick,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(CardArtwork, {
            item: item,
            intersect: intersect,
            showValuePlanLabel: showValuePlanLabel
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.infoContainer,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.info,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.title,
                children: /*#__PURE__*/_jsx("p", {
                  children: item.name
                })
              }), /*#__PURE__*/_jsx("div", {
                className: styles.delivery,
                children: /*#__PURE__*/_jsx("span", {
                  children: deliveryLabel(item)
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "".concat(styles.feature),
              children: props_.focusIndex != null && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.title,
                  children: /*#__PURE__*/_jsx("p", {
                    children: item.name
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.genre,
                  children: item.genres.map(function (genre) {
                    return genre.name;
                  }).join("/")
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.description,
                  children: /*#__PURE__*/_jsx("p", {
                    children: item.description
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.delivery,
                  children: [/*#__PURE__*/_jsx("span", {
                    children: deliveryLabel(item)
                  }), " ", /*#__PURE__*/_jsx("span", {
                    children: deliveryDate(item)
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.other,
                  children: [!context.hiddenPrice && item.rights && item.rights.length != 0 && price(item), context.hiddenPrice && /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx(FavoriteButton, {
                    metaId: item.id,
                    className: styles.favorite,
                    fillGray: true,
                    scale: true,
                    text: "\u304A\u6C17\u306B\u5165\u308A"
                  })]
                })]
              })
            })]
          })]
        })
      })
    })
  });
}